import moment from 'moment-timezone';

import { decorateAdditionalOptionsString } from './trip';

moment.tz.setDefault('Asia/Bangkok');

export function parseQueryToData(query) {
  const data = {
    promo: null,
    trip: null,
    date: null,
    quantity: null,
    requestType: 'message',
    device: 'mobile',
  };
  if (query.promo) data.promo = query.promo;
  if (query.trip) data.trip = query.trip;
  if (query.date) data.date = moment(query.date, 'DD-MM-YYYY').toISOString();
  if (query.quantity) data.quantity = parseInt(query.quantity, 10);
  if (query.requestType) data.requestType = query.requestType;
  if (query.device) data.device = query.device;
  return data;
}

export function isMultiTier(trip) {
  if (trip.multi_tier_prices && trip.multi_tier_prices.length > 0) return true;
  return false;
}

export function isMultiTierSupportForeignPrices(trip) {
  if (trip.foreign_multi_tier_prices) return true;
  return false;
}

export function parseDataToQuery(data) {
  let base = '/booking/new';
  const query = [];
  if (data.step && data.step !== 1) query.push(`step=${data.step}`);
  if (data.trip && data.trip.slug) query.push(`trip=${data.trip.slug}`);
  if (data.date) query.push(`date=${moment(data.date).format('DD-MM-YYYY')}`);
  if (data.trip && isMultiTier(data.trip)) {
    if (data.tier >= 0 && data.subTiers) {
      query.push(`tier=${data.tier}&subTiers=${data.subTiers.join(',')}`);
    }
  } else if (data.trip && data.trip.product_type === 'car_rental') {
    if (data.options && data.options.carRental) {
      const { from, to } = data.options.carRental;
      const quantity = Math.abs(to.startOf('day').diff(from.startOf('day'), 'days')) + 1;
      query.push(`date=${from.format('DD-MM-YYYY')}`);
      query.push(`quantity=${quantity}`);
    }
  } else if (data.quantity) query.push(`quantity=${data.quantity}`);
  if (data.requestType) query.push(`requestType=${data.requestType}`);
  if (data.device) query.push(`device=${data.device}`);
  if (data.options) {
    const optionsString = decorateAdditionalOptionsString(data.options);
    if (optionsString.length > 0) query.push(optionsString);
  }
  if (data.acceptSwap) query.push('acceptSwap=true');
  if (data.deliveryLocation) query.push(`deliveryLocation=${data.deliveryLocation}`);
  if (query.length > 0) {
    base += `?${query.join('&')}`;
  }
  return base;
}

function parseDataToQueryV2(fixPath, data) {
  let base = `${fixPath}/booking/new`;
  const query = [];
  if (data.step && data.step !== 1) query.push(`step=${data.step}`);
  if (data.trip && data.trip.slug) query.push(`trip=${data.trip.slug}`);
  if (data.date) query.push(`date=${moment(data.date).format('DD-MM-YYYY')}`);
  if (data.trip && isMultiTier(data.trip)) {
    if (data.tier >= 0 && data.subTiers) {
      query.push(`tier=${data.tier}&subTiers=${data.subTiers.join(',')}`);
    }
  } else if (data.trip && data.trip.product_type === 'car_rental' && data.options && data.options.carRental) {
    const { from, to } = data.options.carRental;
    const quantity = Math.abs(to.startOf('day').diff(from.startOf('day'), 'days')) + 1;
    query.push(`date=${from.format('DD-MM-YYYY')}`);
    query.push(`quantity=${quantity}`);
  } else if (data.quantity) query.push(`quantity=${data.quantity}`);
  if (data.requestType) query.push(`requestType=${data.requestType}`);
  if (data.device) query.push(`device=${data.device}`);
  if (data.options) {
    const optionsString = decorateAdditionalOptionsString(data.options);
    if (optionsString.length > 0) query.push(optionsString);
  }
  if (data.acceptSwap) query.push('acceptSwap=true');
  if (data.deliveryLocation) query.push(`deliveryLocation=${data.deliveryLocation}`);
  if (query.length > 0) {
    base += `?${query.join('&')}`;
  }
  return base;
}

export const createBookLink = (fixPath, requestType, trip, date, quantity, otherOptions, multiTier) => {
  const paymentData = {
    trip,
    requestType,
    device: 'desktop',
    ...quantity.quantity ? { quantity: quantity.quantity } : {},
    ...quantity.childQuantity ? { options: { childQuantity: quantity.childQuantity } } : {},
    step: 1,
  };
  if (date) {
    paymentData.date = moment(date);
  }
  if (trip.product_type === 'trip' && otherOptions.acceptSwap) {
    paymentData.acceptSwap = true;
  }
  if (trip.product_type === 'ticket') {
    const tierIndex = multiTier.findIndex(tier => tier.active);
    if (tierIndex !== -1) {
      const subTierData = multiTier[tierIndex].sub_tiers.map(subTier => subTier.quantity);
      paymentData.tier = tierIndex;
      paymentData.subTiers = subTierData;
    }
  }
  return parseDataToQueryV2(fixPath, paymentData);
};

export const createRequestBookLink = (fixPath, requestType, trip, quantity, childQuantity, selectedDate, acceptSwap) => {
  const options = { childQuantity };
  const paymentData = {
    trip,
    quantity,
    requestType,
    device: 'desktop',
    options,
    step: 1,
  };
  if (options && options.customTripSlug && options.customTripId) {
    paymentData.trip.slug = options.customTripSlug;
    paymentData.trip._id = options.customTripId;
  }
  if (selectedDate) {
    paymentData.date = moment(selectedDate);
  }
  if (acceptSwap) {
    paymentData.acceptSwap = true;
  }
  return parseDataToQueryV2(fixPath, paymentData);
};
